// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_pageWrapper__gkStj"};